export class SecurityPerEnterprise{

  enterpriseId: number;
  passwordWillExpire = false;
  passwordExpirationInDays = 90;
  failedLoginDeactivateAccount = false;
  nbMaxOfFailedLogin = 3;

  minSizePwd = 4;
  minNbUpperCase = 0;
  minNbLowerCase = 0;
  minSpecialChar = 0;
  minNumberDigit = 0;
  passwordsAreHidden = false;
  usernamesAreHidden = false;
  punchBadgesAreHidden = false;
  employeeDOBHidden = false;
  employeeAddressHidden = false;
  employeeCityHidden = false;
  employeePostalCodeHidden = false;
  employeeProvinceOrStateHidden = false;
  employeeCountryHidden = false;
  maxInactivityInDays = 45;
  employeeEmailHidden = false;
  employeeTelephoneHidden = false;
  employeeGenderHidden = false;

}
